export const ROUTES = {
  HOME: "/",
  LOGIN: "/login",
  DASHBOARD: "/dashboard",

  PRODUCTS: "/produtos",
  PRODUCT_DETAIL: "/produtos/:id",
  STOCK: "/estoque",
  STOCK_DETAIL: "/estoque/:id",
  CLIENTS: "/clientes",
  SELLERS: "/vendedores",
  COMMISSIONS: "/comissoes",
  COMMISSION_RATES: "/taxas-comissao",
  TAGS: "/tags",
  DEVOLUTIONS: "/devolucoes",
  MAINTENANCES: "/manutencao",
  CONTRACTS: "/contratos",
  RENTALS: "/alugueis",
  RENTAL_CREATE: "/alugueis/novo",
  RENTAL_CREATE_ADMIN: "/alugueis/novo-admin",
  RENTALS_VIEW: "/ver-alugueis",
  RENTAL_PICKUP: "/retirada",
  INVOICES: "/notas-fiscais",
  COMMERCIAL_INVOICES: "/notas-comerciais",
  FISCAL_EXPORT: "/exportacao-fiscal",
  GRADUATIONS: "/formaturas",

  NOT_FOUND: "/404",
} as const;

export type Route = (typeof ROUTES)[keyof typeof ROUTES];
